import { ConfigProviderProps } from "antd/lib/config-provider";

export const config: ConfigProviderProps = {
  componentSize: "large",
  theme: {
    token: {
      colorPrimary: "#1b7dd4",
      colorInfo: "#1b7dd4",
      colorSuccess: "#3fa672",
      colorError: "#d9363e",
      colorTextBase: "#0f1b2d",
      colorLink: "#1b7dd4",
      colorLinkHover: "#1670c2",
      colorBorder: "#d9dee6",
      colorBorderSecondary: "#e4e8ef",
      colorFillSecondary: "#f5f5f5",
      colorBgContainerDisabled: "rgba(0, 0, 0, 0.04)",
      colorTextDisabled: "rgba(0, 0, 0, 0.25)",
      borderRadius: 8,
      controlHeight: 44,
      fontFamily:
        '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    },
    components: {
      Button: {
        controlHeight: 46,
        borderRadius: 8,
        fontWeight: 600,
        primaryShadow: "0 2px 6px rgba(27, 125, 212, 0.25)",
      },
      Input: {
        controlHeight: 44,
        borderRadius: 8,
        activeShadow: "0 0 0 3px rgba(27, 125, 212, 0.15)",
        paddingInline: 14,
      },
      Form: {
        labelColor: "#3a4a60",
        labelFontSize: 13,
        itemMarginBottom: 16,
      },
      Checkbox: {
        borderRadiusSM: 4,
      },
      Radio: {
        colorPrimary: "#00b96b",
      },
      Select: {
        optionHeight: 10,
      },
    },
  },
};
